import { render, staticRenderFns } from "./ListArticleListItem.vue?vue&type=template&id=49dba346&scoped=true"
import script from "./ListArticleListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListArticleListItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListArticleListItem.vue?vue&type=style&index=0&id=49dba346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dba346",
  null
  
)

export default component.exports